const PastRoutine = ({ handleHubChange }) => {
  return (
    <button
      className='bg-secondary rounded-xl p-4'
      onClick={() => handleHubChange('PAST_ROUTINE')}
    >
      <div className='flex items-center gap-4 mb-4'>
        <h2 className='text-lg font-semibold'>Past Routine</h2>
      </div>
      <p className='text-sm text-gray-400 mb-4 text-left'>
        View your past workout plans
      </p>
    </button>
  );
};

export default PastRoutine;
